import { render, staticRenderFns } from "./car2-desktop.vue?vue&type=template&id=a31bb982&"
import script from "./car2-desktop.vue?vue&type=script&lang=js&"
export * from "./car2-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarSliderModel: require('/var/www/components/car/car-slider-model.vue').default,FormCreditMini: require('/var/www/components/form/form-credit-mini.vue').default,CarTech2: require('/var/www/components/car/car-tech2.vue').default,CarBuyUpperPrice: require('/var/www/components/car/car-buy-upper-price.vue').default,CarBuyUpperButtons: require('/var/www/components/car/car-buy-upper-buttons.vue').default,CarBuyUpperPhoneVin: require('/var/www/components/car/car-buy-upper-phone-vin.vue').default,CarOwnershipCost: require('/var/www/components/car/car-ownership-cost.vue').default,CarComplectation2: require('/var/www/components/car/car-complectation2.vue').default,CarBenefits: require('/var/www/components/car/car-benefits.vue').default,CarLocationPhones: require('/var/www/components/car/car-location-phones.vue').default,Baner: require('/var/www/components/baner/baner.vue').default,CatalogListCar: require('/var/www/components/catalog/catalog-list/catalog-list-car.vue').default,SeoTextAbout: require('/var/www/components/seo-text/seo-text-about.vue').default,SkeletonCar: require('/var/www/components/skeleton/skeleton-car.vue').default})
